var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('line-chart',{attrs:{"chart-data":_vm.datacollection}}),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.fillData()}}},[_vm._v("Randomize")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }